import MediaPlayer from "../MediaPlayer";
import m, {Vnode} from "mithril";
import {secondsToTime} from "../utils/timeConvert";

export default class CurrentTime {
    constructor(
        public readonly player: MediaPlayer
    ) { }

    public view(): Vnode {
        return m('div.currentTime', {},  secondsToTime(this.player.currentTime()));
    }
}
